<template>
  <div>
    <div class="w-100 cover"></div>
    <div class="f3-ns f4 mt3">
        <div class="w-70-ns w-100 center mv4 info tc">
          <div class="pa2 f2">All<span class="red">on</span> Construction</div>
          <div class="mv3">      
            <div class="black link db f4"><a href="tel:+18189150605" class="dim black link">(818) 915 - 0605</a> | 
            <a class="dim red link" href="https://www2.cslb.ca.gov/OnlineServices/CheckLicenseII/LicenseDetail.aspx?LicNum=630785" target="_blank">License #630785 </a></div>
          </div>
          <!-- <a href="mailto:allonconstruction@gmail.com" class="dim black link">
            allonconstruction@gmail.com
          </a> -->
          <div class="mt5-ns mt4 ph4">
            Send us a message for a free estimate or some helpful advice!
          </div>
      </div>
      <!-- <div class="tc center">
        <iframe class="w-33-ns w-100 tc" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.3429724931534!2d-74.00995598439003!3d40.710465745646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a181565da7d%3A0xff49ee1e6a8ef416!2sUnited%20Builders%20Group%20LLC!5e0!3m2!1sen!2sus!4v1573949549226!5m2!1sen!2sus" width="400" height="300" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
      </div> -->
      
    <Form/>
  </div>
  </div>
</template>

<script>
// import cover from '@/assets/murietta/1.jpg'
import Form from '@/components/Form.vue'
export default {
  name: 'Contact',
  components: { Form }
}
</script>

<style scoped>
.b1 {
  font-weight: 500;
}
.cover {
  background: url('../assets/murietta/1.jpg');
  height: 70vh;
  background-position: 80% 70%;
  text-align: center;
  margin: auto;
}

@media only screen 
and (min-device-width : 375px) 
and (max-device-width : 812px)
and (-webkit-device-pixel-ratio : 3) { 
  .cover {
    background-position: 54% 0%;
  }
}
/* .mapouter {
  position:relative;
  text-align:right;
  max-height:500px;
  max-width:600px;
}
.gmap_canvas {
  overflow:hidden;
  background:none !important;
  max-height:500px;
  max-width:600px;
} */
</style>
